import { createContext } from 'react';


export interface ScreenContextValue {
  width: number;
  height: number;
}

export const getScreenContextValue = () => {
  return {
    width: document.body.clientWidth,
    height: document.body.clientHeight
  };
}

const ScreenContext = createContext<ScreenContextValue>(getScreenContextValue());

export default ScreenContext;
